<template>
  <div>
    <NoSearchBarHeader></NoSearchBarHeader>
    <div class="row-container ph3 flc">
      <iframe frameborder="0" scrolling="no" class="no-out" :src="url" width="100%" :height="height" ></iframe>
    </div>
    <NoContactBarFooter></NoContactBarFooter>
  </div>
</template>

<script>
import { getComponent, trackPageView, getSiteName, getLanguage, capitalize } from '@/utils/common';
import NoContactBarFooter from '@/components/footer/zen_no_contact_bar.vue';
import NoSearchBarHeader from '@/components/header/zen_slim.vue';
export default {
  name: 'solve-ticket',
  components: {
    NoContactBarFooter,
    NoSearchBarHeader
  },
  data() {
    return {
      siteName: '',
      ticketId: '',
      code: '',
      language: '',
      url: '',
      height: '250px'
    };
  },
  created() {
    trackPageView('solve-ticket');
  },
  metaInfo() {
    return {
      titleTemplate: `${this.$t('requestTitle')} - %s `
    };
  },
  computed: {
    headerComponent() {
      return getComponent(this.$store.getters.flowObject, 'header');
    },
    footerComponent() {
      return getComponent(this.$store.getters.flowObject, 'footer');
    },
    languageDropdownComponent() {
      return getComponent(this.$store.getters.flowObject, 'languageDropdown');
    },
    loginLink() {
      return `https://members.${this.$store.state.siteDetails.domain_name}/login`;
    },
    MALink() {
      return `https://members.${this.$store.state.siteDetails.domain_name}`;
    },
    signupLink() {
      return `https://www.${this.$store.state.siteDetails.domain_name}/signup`;
    },
    logoUrl() {
      return this.$store.state.siteDetails.logo_url;
    }
  },
  mounted() {
    this.getParameters();
    window.addEventListener('message', this.resizeIframe);
    window.addEventListener('message', this.iFrameRedirect);
  },
  methods: {
    resizeIframe(event) {
      if (!event.data.height) {
        return;
      }
      this.height = event.data.height;
    },
    iFrameRedirect(event) {
      if (event.data.type !== 'redirect') {
        return;
      }
      window.location.href = event.data.url;
    },
    getParameters() {
      let siteNameFound = getSiteName();
      this.siteName = siteNameFound ? capitalize(siteNameFound) : '';
      this.language = getLanguage();
      let queryString;
      if (this.$route.query) {
        const queryStringItems = Object.keys(this.$route.query).map(key => `${key}=${this.$route.query[key]}`);
        queryString = queryStringItems.join('&');
      }
      let iframeHost = 'https://csbp-iframe.blackpants.systems';
      if (process.env.NODE_ENV === 'development') {
        iframeHost = 'http://localhost:8081';
      }
      // eslint-disable-next-line max-len
      this.url = `${iframeHost}/#/?siteName=${this.siteName}&domainName=${this.$store.state.siteDetails.domain_name}&language=${this.language}${queryString ? `&${queryString}` : ''}`;
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped="true">
@import '@/styles/variables.scss';
iframe {
  overflow: hidden;
}
.row-container {
  min-height: 600px;
}
.form {
  max-width: 650px;
}
.input-group {
  margin-bottom: 25px;

  .btn {
    background-color: #0072ef;
    border: 0;
    border-radius: 4px;
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
    line-height: 2.72;
    min-width: 190px;
    padding: 0 1.9286em;
    max-width: 100%;
    box-sizing: border-box;
    outline: none;
    transition: border 0.12s ease-in-out;
    cursor: pointer;

    @media (min-width: 768px) {
      width: auto;
    }
    &:hover,
    &:focus,
    &:active {
      background-color: #004189;
    }
  }
}
</style>
